/**
 * Accounts-payable financial-control ids (ALC-4519), in catalog order. Only the AP domain edits
 * this file; another domain (e.g. AR, ALC-4534) adds its own `<domain>.ts` next to it.
 */
export const AP_FINANCIAL_CONTROL_IDS = [
  'AP03',
  'AP04',
  'AP05',
  'AP06',
  'AP07',
  'AP08',
  'AP09',
  'AP10',
  'AP11',
  'AP_GL05',
] as const;
